import {
    useGetWages,
    useSetWages
} from "../../../../services/react-query/setting/wages";
import { useEffect, useState } from "react";
import {
    deepCopy,
    formatObjectNumbers
} from "../../../../utils/common";

const AFFILIATE_FIELDS = [
    'p2pPercent',
    'p2pPercentMin',
    'p2pPercentMax',

    'otcPercent',
    'otcPercentMin',
    'otcPercentMax',

    'internalTransferPercent',
    'internalTransferPercentMin',
    'internalTransferPercentMax',

    'swapPercent',
    'swapPercentMin',
    'swapPercentMax',

    'cardPercent',
    'cardPercentMin',
    'cardPercentMax'
];

const useAffiliateSetting = () => {
    const {
        data: wages,
        isFetching: fetchingWages
    } = useGetWages();

    const {
        mutate: updateWages,
        isLoading: updatingWages
    } = useSetWages();

    const [detailsChanged, setDetailsChanged] = useState(false);
    const [affiliateData, setAffiliateData] = useState(null);

    useEffect(() => {
        if (wages?.affiliate) {
            setAffiliateData(deepCopy(wages.affiliate));
        }
    }, [wages]);

    const checkChanges = () => {
        const cache = wages?.affiliate;

        if (!cache || !affiliateData) {
            setDetailsChanged(false);
            return;
        }

        const changed = AFFILIATE_FIELDS.some(
            field => cache[field] != affiliateData[field]
        );

        setDetailsChanged(changed);
    };

    const onInputValueChange = (v, type) => {
        setAffiliateData(state => ({
            ...state,
            [type]: v
        }));
    };

    useEffect(() => {
        checkChanges();
    }, [affiliateData]);

    const onSubmitClicked = () => {
        const newWages = deepCopy(wages);

        newWages.affiliate = formatObjectNumbers(affiliateData);

        updateWages({
            data: newWages
        });
    };

    return {
        affiliateData,
        onInputValueChange,
        loading: fetchingWages || updatingWages,
        detailsChanged,
        onSubmitClicked
    };
};

export default useAffiliateSetting;